<div class="auth-wrapper">
  <div *ngIf="loader" id="loader"></div>

  <div class="hero card-glass mb-3">
    <p class="eyebrow">Spay · Création de compte</p>
    <h1 class="mb-1">Créez votre compte</h1>
    <p class="lead">Un parcours guidé en 5 étapes pour ouvrir votre portefeuille Spay.</p>
  </div>

  <div class="card card-glass p-3">
    <div class="step-header mb-3">
      <div class="step-titles">
        <div class="step-item" [class.active]="currentStep >= 1" [class.current]="currentStep === 1">
          <span class="step-index">1</span>
          <span class="step-label">Membre</span>
        </div>
        <div class="step-item" [class.active]="currentStep >= 2" [class.current]="currentStep === 2">
          <span class="step-index">2</span>
          <span class="step-label">Identité</span>
        </div>
        <div class="step-item" [class.active]="currentStep >= 3" [class.current]="currentStep === 3">
          <span class="step-index">3</span>
          <span class="step-label">Contact</span>
        </div>
        <div class="step-item" [class.active]="currentStep >= 4" [class.current]="currentStep === 4">
          <span class="step-index">4</span>
          <span class="step-label">Sécurité</span>
        </div>
        <div class="step-item" [class.active]="currentStep >= 5" [class.current]="currentStep === 5">
          <span class="step-index">5</span>
          <span class="step-label">Confirmation</span>
        </div>
      </div>
      <div class="step-progress">
        <div class="step-progress-bar" [style.width.%]="stepProgress()"></div>
      </div>
    </div>

    <form [formGroup]="signUp" (ngSubmit)="onSubmit()" class="row g-3">
      <ng-container *ngIf="currentStep === 1">
        <div class="col-12">
          <label class="form-label">Numéro membres</label>
          <input formControlName="numeroMembres" name="numeroMembres" class="form-control" type="text" required>
          <small *ngIf="numeroMembres.invalid && (numeroMembres.dirty || numeroMembres.touched)" class="text-danger">
            3 à 32 caractères, lettres/chiffres/underscore/tiret
          </small>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 2">
        <div class="col-md-6">
          <label class="form-label">Nom</label>
          <input formControlName="firstName" name="firstName" class="form-control" type="text" required>
          <small *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="text-danger">Au moins 2 caractères</small>
        </div>

        <div class="col-md-6">
          <label class="form-label">Prénom</label>
          <input formControlName="lastName" name="lastName" class="form-control" type="text" required>
          <small *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="text-danger">Au moins 2 caractères</small>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 3">
        <div class="col-md-6">
          <label class="form-label">Email</label>
          <input formControlName="email" #emaild (blur)="isEmail(emaild.value)" name="email" class="form-control" type="email" required>
          <small *ngIf="email.invalid && (email.dirty || email.touched)" class="text-danger">Email invalide</small>
          <small *ngIf="emailexist && email.valid" class="text-danger">Email déjà utilisé</small>
        </div>

        <div class="col-md-6">
          <label class="form-label">Numéro de téléphone</label>
          <input formControlName="phone" #phoned (blur)="isPhone(phoned.value)" name="phone" class="form-control" type="tel" required>
          <small *ngIf="phone.invalid && (phone.dirty || phone.touched)" class="text-danger">Numéro invalide</small>
          <small *ngIf="phonexist && phone.valid" class="text-danger">Numéro déjà utilisé</small>
        </div>

        <div class="col-md-6">
          <label class="form-label">Votre pays</label>
          <select class="form-select" id="pays" formControlName="codePays">
            <option value="237">Cameroun</option>
            <option value="238">Gabon</option>
            <option *ngFor="let p of payslist" [value]="p.code">{{ p.nom }}</option>
          </select>
          <small *ngIf="codePays.invalid && (codePays.dirty || codePays.touched)" class="text-danger">Pays requis</small>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 4">
        <div class="col-md-6">
          <label class="form-label">Mot de passe</label>
          <input
            formControlName="password"
            #pass
            (focus)="showvalidationpart()"
            (blur)="hidevalidationpart()"
            (keyup)="validateValue(pass.value)"
            name="password"
            class="form-control"
            [type]="show ? 'text' : 'password'"
            id="pass"
            required>
          <small *ngIf="password.invalid && (password.dirty || password.touched)" class="text-danger">Mot de passe invalide</small>

          <div *ngIf="validation" class="password-hints mt-1">
            <p [ngStyle]="{ 'color': letterchange ? 'lightgreen' : '#ff9b9b' }">Minuscule</p>
            <p [ngStyle]="{ 'color': capitalchange ? 'lightgreen' : '#ff9b9b' }">Majuscule</p>
            <p [ngStyle]="{ 'color': numberchange ? 'lightgreen' : '#ff9b9b' }">Chiffre</p>
            <p [ngStyle]="{ 'color': symbolechange ? 'lightgreen' : '#ff9b9b' }">Symbole</p>
            <p [ngStyle]="{ 'color': lengthchange ? 'lightgreen' : '#ff9b9b' }">8-16 caractères</p>
          </div>
        </div>

        <div class="col-md-6">
          <label class="form-label">Confirmer le mot de passe</label>
          <input formControlName="confirmPassword" name="confirmPassword" class="form-control" [type]="show ? 'text' : 'password'" required>
          <small *ngIf="confirmPassword.invalid && (confirmPassword.dirty || confirmPassword.touched)" class="text-danger">Mot de passe invalide</small>
          <small *ngIf="signUp.hasError('mismatch') && (confirmPassword.dirty || confirmPassword.touched)" class="text-danger">Les mots de passe ne correspondent pas</small>
        </div>

        <div class="col-12 d-flex align-items-center gap-2">
          <input type="checkbox" class="form-check-input mt-0" (click)="showPassword()" id="showPass">
          <label class="form-check-label" for="showPass">Afficher les mots de passe</label>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 5">
        <div class="col-12">
          <div class="review-card">
            <h3 class="review-title">Vérifiez vos informations</h3>

            <div class="review-grid">
              <div class="review-row"><span>Numéro membres</span><strong>{{ numeroMembres.value }}</strong></div>
              <div class="review-row"><span>Nom</span><strong>{{ firstName.value }}</strong></div>
              <div class="review-row"><span>Prénom</span><strong>{{ lastName.value }}</strong></div>
              <div class="review-row"><span>Email</span><strong>{{ email.value }}</strong></div>
              <div class="review-row"><span>Téléphone</span><strong>{{ phone.value }}</strong></div>
              <div class="review-row"><span>Code pays</span><strong>{{ codePays.value }}</strong></div>
            </div>

            <p class="review-note">En validant, vous acceptez la création de votre compte Spay.</p>
          </div>
        </div>
      </ng-container>

      <div class="col-12 d-flex justify-content-between align-items-center mt-2 step-actions">
        <button type="button" class="btn btn-outline-light btn-pill" (click)="previousStep()" [disabled]="currentStep === 1 || loader">
          Précédent
        </button>

        <button type="button" class="btn btn-primary btn-pill" *ngIf="currentStep < totalSteps" (click)="nextStep()" [disabled]="loader">
          Suivant
        </button>

        <button type="submit" class="btn btn-success btn-pill" *ngIf="currentStep === totalSteps" [disabled]="loader || signUp.invalid || phonexist || emailexist">
          Créer mon compte
        </button>
      </div>
    </form>
  </div>
</div>
